import axios from "axios"
import Buefy from "buefy"
import Vue from "vue"
import VueRouter from "vue-router"
import App from "./App.vue"
import "./filters.js"
import AppRouter from "./AppRouter"
import Environment from "./services/Environment.js"
import { store } from "./store"
import "./validate"
import { UsuarioService } from "./services"

// ---------------------------------------- Axios ----------------------------------------

axios.defaults.baseURL = `${Environment.url}`
axios.interceptors.request.use(
    function (config) {
        store.dispatch("AppStore/_loadingOn")
        const usuario = UsuarioService.getUsuario()
        config.headers.common.Authorization = usuario ? `Bearer ${usuario.token}` : ""
        config.headers.common.usuId = usuario ? usuario.usu_id : ""
        config.headers.common.pveId = usuario ? usuario.pve_id : ""
        config.headers.common.cliId = usuario ? usuario.cli_id : ""
        return config
    },
    function (error) {
        store.dispatch("AppStore/_loadingOff")
        return Promise.reject(error)
    }
)
axios.interceptors.response.use(
    function (response) {
        store.dispatch("AppStore/_loadingOff")
        return response
    },
    function (error) {
        store.dispatch("AppStore/_loadingOff")
        return Promise.reject(error)
    }
)

// ---------------------------------------- Vue ----------------------------------------

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(Buefy, {
    defaultToastDuration: 3500
})

new Vue({
    router: AppRouter,
    store,
    render: h => h(App)
}).$mount("#app")
